import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

type AccessGatePanelProps = {
    title: string;
    description: string;
    children: ReactNode;
    className?: string;
};

export function AccessGatePanel({ title, description, children, className }: AccessGatePanelProps) {
    return (
        <div className={cn("flex min-h-[50vh] flex-1 items-center justify-center p-6", className)}>
            <Card className="w-full max-w-md">
                <CardHeader>
                    <CardTitle>{title}</CardTitle>
                    <CardDescription>{description}</CardDescription>
                </CardHeader>
                <CardContent>{children}</CardContent>
            </Card>
        </div>
    );
}
